const userId = window.localStorage.getItem('id')

export {
    userId
}
